import { makeStyles } from '@material-ui/core/styles'
import { pageContentHorizontalGutters } from 'lib/styles/page-content-gutters'

const useStyles = makeStyles(theme => ({
  container: pageContentHorizontalGutters(theme, {
    paddingTop: theme.spacing(2),
    margin: '0 0 60px',
    width: 'auto',
    sm: {
      paddingTop: theme.spacing(2),
      margin: '10px 0 60px',
    },
  }),
}))

export default useStyles
